import { BaseQueryWithValidationClass } from 'src/editor/api/queries/utils/query-with-validation-class'
import {
  getWhiteLabelBrandSettings,
  WL_BRAND_SETTINGS_API_URL,
} from 'src/editor/api/white-label-brand-api'
import { WhiteLabelBrandSettingsInterface } from 'src/shared/types/brand-settings-interface'

class WhiteLabelBrandSettingsQueryClass extends BaseQueryWithValidationClass<
  [],
  WhiteLabelBrandSettingsInterface
> {
  queryFn = getWhiteLabelBrandSettings
  getQueryKey = () => [WL_BRAND_SETTINGS_API_URL] as const
}
export const whiteLabelBrandSettingsQuery =
  new WhiteLabelBrandSettingsQueryClass()
